import { FC } from 'react';

import emblem from '@/assets/emblem.svg';
import BoxInfoOffer from '@/components/ui/BoxInfoOffer';

import { useLingui } from '@lingui/react';

interface Props {
  courtOfFirstInstance: string;
  courtOfFirstInstanceSignature: string;
  courtOfSecondInstance: string;
  courtOfSecondInstanceSignature: string;
}

const YourCaseInfo: FC<Props> = ({
  courtOfFirstInstance,
  courtOfFirstInstanceSignature,
  courtOfSecondInstance,
  courtOfSecondInstanceSignature,
}) => {
  const { i18n } = useLingui();

  return (
    <div className="text-dark-gray-500 lg:max-w-[440px]">
      <h2 className="h4 mb-3 text-center">{i18n.t('Dane Twojej sprawy')}</h2>
      <div className="mb-4 hidden h-px w-full bg-dark-gray-100 lg:block" />
      <div className="grid gap-2 lg:gap-x-5 lg:gap-y-3">
        <BoxInfoOffer
          label={i18n.t('Sąd I Instancji')}
          value={courtOfFirstInstance || i18n.t('Brak informacji')}
          logo={emblem}
        />
        <BoxInfoOffer
          label={i18n.t('Sygnatura akt I')}
          value={courtOfFirstInstanceSignature || i18n.t('Brak informacji')}
        />
        <div className="h-px w-full bg-dark-gray-100" />
        <BoxInfoOffer
          label={i18n.t('Sąd II Instancji')}
          value={courtOfSecondInstance || i18n.t('Brak informacji')}
          logo={emblem}
        />
        <BoxInfoOffer
          label={i18n.t('Sygnatura akt II')}
          value={courtOfSecondInstanceSignature || i18n.t('Brak informacji')}
        />
      </div>
    </div>
  );
};

export default YourCaseInfo;
